module.exports = {
	"ha": "nha",
	"id": 5.7,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by HSDA, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.85714285714286,
						"dataLabels": {
							"enabled": true,
							"format": "39"
						}
					},
					{
						"y": 59.523809523809526,
						"dataLabels": {
							"enabled": true,
							"format": "25"
						}
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "24"
						}
					},
					{
						"y": 52.38095238095239,
						"dataLabels": {
							"enabled": true,
							"format": "22"
						}
					},
					{
						"y": 33.33333333333333,
						"dataLabels": {
							"enabled": true,
							"format": "14"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.87234042553192,
						"dataLabels": {
							"enabled": true,
							"format": "184"
						}
					},
					{
						"y": 84.57446808510637,
						"dataLabels": {
							"enabled": true,
							"format": "159"
						}
					},
					{
						"y": 80.31914893617021,
						"dataLabels": {
							"enabled": true,
							"format": "151"
						}
					},
					{
						"y": 69.14893617021278,
						"dataLabels": {
							"enabled": true,
							"format": "130"
						}
					},
					{
						"y": 30.319148936170215,
						"dataLabels": {
							"enabled": true,
							"format": "57"
						}
					},
					{
						"y": null
					},
					{
						"y": 95.65217391304348,
						"dataLabels": {
							"enabled": true,
							"format": "66"
						}
					},
					{
						"y": 89.85507246376811,
						"dataLabels": {
							"enabled": true,
							"format": "62"
						}
					},
					{
						"y": 84.05797101449275,
						"dataLabels": {
							"enabled": true,
							"format": "58"
						}
					},
					{
						"y": 76.81159420289855,
						"dataLabels": {
							"enabled": true,
							"format": "53"
						}
					},
					{
						"y": 42.028985507246375,
						"dataLabels": {
							"enabled": true,
							"format": "29"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.89743589743589,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.36363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.586956521739136,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.031446540880502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.907284768211925,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -56.15384615384615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.060606060606055,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.451612903225811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.62068965517241,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -45.28301886792453,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Northeast<br>n=42"
			},
			{
				"x": 9,
				"text": "Northern Interior<br>n=188"
			},
			{
				"x": 15,
				"text": "Northwest<br>n=69"
			}
		],
		"dataTable": {
			"Northeast": [
				42,
				39,
				25,
				24,
				22,
				14
			],
			"Northern Interior": [
				188,
				184,
				159,
				151,
				130,
				57
			],
			"Northwest": [
				69,
				66,
				62,
				58,
				53,
				29
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_7.json
// module id = 274
// module chunks = 0